module.exports = __webpack_public_path__ + "static/media/us_staff4.9b525400.jpg";